// extracted by mini-css-extract-plugin
export default {"ColleagueSelectorContainer":"_ColleagueSelectorContainer--x6A3q","InactiveColleague":"_InactiveColleague--I0exr","MatchAllWrapper":"_MatchAllWrapper--bl0pt"};